import { FromSchema } from 'libs/entities/common/src/SchemaOperations';
import { z } from 'zod';

export const CreditSafeReportComplianceSchema = z
    .object({
        taxLienFilings: z.number(),
        judgmentFilings: z.number(),
        suits: z.number(),
        uccFilings: z.number(),
        possibleOfac: z.boolean(),
    })
    .strict();

export class CreditSafeReportCompliance extends FromSchema(CreditSafeReportComplianceSchema) {
    taxLienFilings: number;
    judgmentFilings: number;
    suits: number;
    uccFilings: number;
    possibleOfac: boolean;
}
